import { tokenAxios } from "@/utils/axios";
import { useAppState } from "@/contexts/app-state";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildApiUrl } from "@/utils/api";

interface UpdateTaoRenderArgs {
    taoId: number;
    practiceId: string;
    requestedUser: string;
    taoRenderStatus: boolean;
    taoRenderStartDate?: string;
}

const postUpdateTaoRenderStatus = async (params: UpdateTaoRenderArgs) => {
    await tokenAxios().post(buildApiUrl("taoManager/updateTaoRenderStatus"), { ...params });
};

export const useUpdateTaoRenderStatus = () => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutate } = useMutation({
        mutationFn: postUpdateTaoRenderStatus,
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["tao-routing-rules"],
          });
        },
      });

    const updateTaoRenderStatus = (taoId: number, taoRenderStatus: boolean, renderStartDate?: string) =>
        mutate({
            taoId: taoId,
            taoRenderStatus: taoRenderStatus,
            practiceId: practiceId,
            requestedUser: loggedInUser,
            taoRenderStartDate: renderStartDate,
        }
    );

        return {
            isPending,
            isError,
            isSuccess,
            updateTaoRenderStatus,
          };
};
